export default __webpack_public_path__ + "static/hero-95f154176929353ba2fe64b72769d6c6.jpg";